@if (electricityOverview) {
  <wl-price-overview-table
    [title]="fields()?.ElectricityCostTitle?.value"
    [faIcon]="'plug'"
    [priceOverview]="electricityOverview"
    [rendering]="rendering()"
  />
}
@if (gasOverview) {
  <wl-price-overview-table
    [title]="fields()?.GasCostTitle?.value"
    [faIcon]="'fire-flame'"
    [priceOverview]="gasOverview"
    [rendering]="rendering()"
  />
}

<div class="cost-section mt-3">
  <div class="d-flex justify-content-between w-100 h5 text-black">
    <span *scText="fields()?.ExpectedYearlyCost" wlCSCapture></span>
    <span wlCSCapture>
      {{
        offer()?.beforeDiscountExpectedYearlyAmount
          | currency: 'EUR' : 'symbol' : '1.2'
      }}
    </span>
  </div>
  @if (hasDiscount()) {
    <div class="d-flex justify-content-between w-100 h5 text-green">
      <span>
        <span *scText="fields()?.DiscountFirstYear" wlCSCapture></span>
        @if (fields()?.DiscountFirstYearTooltip?.value) {
          <wl-tooltip
            class="ps-1"
            [tooltip]="{
              description: fields()?.DiscountFirstYearTooltip?.value,
            }"
          />
        }
      </span>
      <span wlCSCapture>
        - {{ offer()?.discountPrice | currency: 'EUR' : 'symbol' : '1.2' }}
      </span>
    </div>
  }
  <hr class="hr" />
  <div class="d-flex justify-content-between w-100 h5 text-body">
    <span *scText="fields()?.YearlyCost" wlCSCapture></span>
    <span wlCSCapture>{{
      offer()?.expectedYearlyAmount | currency: 'EUR' : 'symbol' : '1.2'
    }}</span>
  </div>
  <div class="d-flex justify-content-between w-100">
    <span>
      <span *scText="fields()?.MonthlyCost" wlCSCapture></span>
      @if (fields()?.MonthlyCostTooltip?.value) {
        <wl-tooltip
          class="ps-1"
          [tooltip]="{
            description: fields()?.MonthlyCostTooltip?.value,
          }"
        />
      }
    </span>
    <span wlCSCapture>{{
      offer()?.expectedMonthlyAmount | currency: 'EUR' : 'symbol' : '1.2'
    }}</span>
  </div>
  @if (!enableRemoveBBA()?.valueOf()) {
    <div class="d-flex justify-content-between w-100">
      <span>
        <span *scText="fields()?.TermCost" wlCSCapture></span>
        @if (fields()?.TermCostTooltip?.value) {
          <wl-tooltip
            class="ps-1"
            [tooltip]="{
              description: fields()?.TermCostTooltip?.value,
            }"
          />
        }
      </span>
      <span wlCSCapture>{{
        offer()?.budgetBillAmount | currency: 'EUR' : 'symbol' : '1.2'
      }}</span>
    </div>
  }
</div>
